const EventInfoCard = ({
  heading = "EVENT",   // pill text
  name,                // bold main title
  subtitle,            // dates / secondary text
  description,         // optional second line
  extra,               // ✅ RIGHT SIDE content (buttons, icons, etc.)
  onClick,             // optional click handler
  color = 'blue'
}) => {
  return (
    <div
      onClick={onClick}
      className={`
        w-full rounded-2xl bg-white
        px-6 py-4
        border border-gray-100
        shadow-sm
        transition-all
        ${onClick ? "cursor-pointer hover:bg-gray-50 hover:shadow-md" : ""}
      `}
    >
      {/* 🔹 TOP ROW: LEFT (PILL + NAME + SUBTITLE) | RIGHT (EXTRA) */}
      <div className="flex items-center justify-between gap-4">
        {/* LEFT SIDE */}
        <div className="flex items-center flex-wrap gap-3 min-w-0">
          {/* PILL */}
          <span
            className={`inline-flex items-center 
              px-4 py-1.5
              rounded-xl
              bg-${color}-500 text-white
              text-xs font-semibold tracking-wide
              flex-shrink-0
            `}
          >
            {heading}
          </span>

          {/* NAME + SUBTITLE */}
          <div className="text-lg sm:text-xl font-semibold text-gray-900 truncate">
            {name}
            {subtitle && (
              <span className="ml-2 text-gray-500 font-normal">
                | {subtitle}
              </span>
            )}
          </div>
        </div>

        {/* ✅ RIGHT SIDE EXTRA SLOT */}
        {extra && (
          <div className="flex items-center flex-shrink-0">
            {extra}
          </div>
        )}
      </div>

      {/* 🔹 DESCRIPTION (SECOND LINE OPTIONAL) */}
      {description && (
        <div className="mt-2 text-sm text-gray-500 truncate">
          {description}
        </div>
      )}
    </div>
  );
};

export default EventInfoCard;
